import { useParams } from 'react-router-dom'

import EditShiftTemplate from 'modules/shift_management/components/Settings/ShiftTemplates/Content/EditShiftTemplate'

const EditShiftTemplatePage = () => {
  const { shiftTemplateId } = useParams()

  return <EditShiftTemplate shiftTemplateId={Number(shiftTemplateId)} />
}

export default EditShiftTemplatePage
